export const getApplicationKey = 'getApplication';
